import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { Paper, Button, TextField, Typography, ButtonBase } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import produce from 'immer';

import { cloneDeep, get } from '../../../../utils/lodash';

import Node from '../../../../common/Node';
import Search from '../../../../common/Search';
import LoaderNew from '../../../../common/LoaderNew';
import CommonStyles from '../../../../common/CommonStyles';
import FullScreenDialog from '../../../../common/FullScreenDialog';
import PredicateChain from '../../../../common/PredicateChain';
import TrplSelect from '../../../../common/TrplControls/TrplSelect';

import ComponentWrapper from '../../../../common/ComponentWrapper';

// import Sorters from './components/Sorters';
import RstFilters from './components/RstFilters';
import Restrictions from './components/Restrictions';
import OtherControls from './components/OtherControls';
import TrplFormEdit from '../TrplFormEdit/TrplFormEdit';
import ViewUsesTree from '../../ViewUsesTree';

import {
  changeArrayElementPosition,
  isNotPlaceholderFilter,
  getPidsFromShowPids,
  getLastRstData,
  isJsonObject,
  onlyUnique,
} from '../../../../utils';

import { updateJels, updateJelsSimple } from '../../../../reducer/jelsReducer';
import { jelTypes } from '../../../../constants';

const styles = {
  rstRow: {
    '&:hover': {
      background: '#f9f9f9',
    },
  },
  tableRowInfo: {
    fontSize: '11px',
    marginRight: '10px',
  },
  notValidAccordeonRst: {
    '& .autocomplete-input': {
      color: 'red',
    },
  },
  tableEditInput: {
    '& .MuiInputBase-input': {
      fontSize: '12px',
    },
  },
  isInAnotherJelContainer: {
    left: '0',
    right: '0',
    top: '32px',
    color: '#fff',
    zIndex: '9999',
    display: 'flex',
    fontSize: '13px',
    position: 'absolute',
    padding: '5px 60px',
    alignItems: 'center',
    background: '#347CFF',
    justifyContent: 'center',
  },
  checkboxGray: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      color: '#675E78',
      fontSize: '18px',
    },
  },
  checkboxLabel: {
    padding: '0px',
    height: '16px',
    fontSize: '12px',
    '& .MuiSvgIcon-root': {
      color: '#675E78',
    },
  },
  ...CommonStyles,
  removeNotValidRstrsBtn: {
    color: 'red',
    fontSize: '12px',
    padding: '5px 15px',
    borderRadius: '5px',
    textTransform: 'none',
    backgroundColor: '#EEECF8',
    '&:hover': {
      backgroundColor: '#EBEBEB',
    },
  },
  rowDragHandle: {
    display: 'flex',
    color: '#C4C4C4',
    marginRight: '10px',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  editFrmIcon: {
    color: '#878787',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
    },
  },
  tableHeadingBtnIcon: {
    fontSize: '16px',
    marginRight: '5px',
  },
  tableHeadingBtn: {
    color: '#878787',
    marginRight: '30px',
    textTransform: 'none',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  tableMenuSelectedBtn: {
    color: '#4E4C4C',
    background: '#EEECF8',
    border: '1px solid #D9D8ED',
    '&:hover': {
      background: '#D9D8ED',
    },
  },
  checkboxGray: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      color: '#675E78',
      fontSize: '18px',
    },
  },
};

class TableEdit extends ComponentWrapper {
  state = {
    init: true,
    initialFilters: [],
    conceptId: null,
    loaded: true,
    isInAnotherJel: '',
    editFrmModal: {
      isOpened: false,
      data: {},
    },
    rstChainModal: {
      isOpened: false,
      rst: 0,
      oid: 0,
    },
    data: {
      setup: {
        locations: {},
      },
    },
    settings: {
      title: '',
      sort_by: 1,
      column_titles: [],
      show_pids: [],
    },
    usedViews: {},
    deepCopyLoaded: true,
    addItemType: 'predicate',
    conceptRestrictionsIds: [],
  };

  componentDidMount = () => {
    const { jels, settings } = this.props;

    let isInAnotherJel = ``;

    if (settings.id) {
      jels.forms.forEach((frmId) => {
        const frm = jels.jelData[frmId];

        frm && frm.groups && frm.groups.forEach((row) => {
          row && row.forEach((group) => {
            if (group.type === 'table' && group.tableId === settings.id)
              isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${frm.id} ${frm.title}`;

            if (group.type === 'links') {
              group.links.forEach((link) => {
                if (link.jel === settings.id)
                  isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${frm.id} ${frm.title}`;
              });
            }
          });
        });
      });
    }

    this.setState({ isInAnotherJel });

    if (settings.concept) this.prepareData(settings.concept);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (JSON.stringify(this.props.settings) !== JSON.stringify(prevProps.settings)) {
      if (this.props.settings.concept) this.prepareData(this.props.settings.concept);
    }
  }

  getConceptData = (cb) => {
    const { setup } = this.props;
    const { conceptId } = this.state;

    if (!conceptId) return

    const data = {
      api_key: setup.id,
      nesting: 1,
      filter: {
        ancestor: conceptId,
        do_individuals: false,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (res) => {
        if (cb) cb(res);
      },
    });
  };

  getAdditionalNodes = (nodes, cb) => {
    const { setup } = this.props;

    const data = {
      api_key: setup.id,
      nesting: 1,
      filter: {
        nodes,
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (res) => {
        if (cb) cb(res.nodes);
      },
    });
  };

  prepareData = (ancestor) => {
    const { init } = this.state;

    const conceptId = ancestor || this.props.conceptId;
    let settings = init ? this.props.settings : this.state.settings;

    if (ancestor) settings.concept = ancestor;

    this.setState({ conceptId, loaded: false }, () => {
      this.getConceptData((data) => {
        const { setup_rbox_light } = this.props.light_meta_and_ops;

        const conceptRestrictionsIds = [];

        if (setup_rbox_light[conceptId] && setup_rbox_light[conceptId].box.r) {
          Object.keys(setup_rbox_light[conceptId].box.r).forEach(key => {
            const conceptRestrictions = setup_rbox_light[conceptId].box.r[key];

            conceptRestrictions.forEach(rst => conceptRestrictionsIds.push(rst.id));
          });
        }

        this.setState({
            data,
            settings,
            init: false,
            loaded: true,
            conceptRestrictionsIds
          }, () => {
            // check if filters have object values
            if (settings.trpl_filter && settings.trpl_filter.length) {
              let additionalNodes = [];

              settings.trpl_filter.forEach(filter => {
                let rst = getLastRstData(filter.pids_chain, conceptId, setup_rbox_light);

                if (rst && rst.primitive === '_obj' && filter) {
                  additionalNodes.push(filter.val);
                }
              });

              // if have - get info about additional nodes
              if (additionalNodes.length) {
                this.getAdditionalNodes(additionalNodes, (additionalNodes) => {
                  const data = { ...this.state.data };
                  data.nodes = { ...data.nodes, ...additionalNodes };

                  this.setState({ data });
                });
              }
            }
          }
        );
      });
    });
  };

  onMainConceptChange = (params) => {
    const { node } = params;
    if (node && node.id) this.prepareData(node.id);
  };

  onRemoveRstClick = (rstIndex) => {
    const settings = { ...this.state.settings };
    const showPidsCopy = [...settings.show_pids];

    if (!settings.column_titles) settings.column_titles = [];
    const columnTitlesCopy = [...settings.column_titles];

    columnTitlesCopy.length = showPidsCopy.length;

    showPidsCopy.splice(rstIndex, 1);
    columnTitlesCopy.splice(rstIndex, 1);

    settings.show_pids = showPidsCopy;
    settings.column_titles = columnTitlesCopy;

    this.setState({ settings });
  };

  switchColumnToMultipleChains = (columnIndex) => {
    const settings = { ...this.state.settings };
    const showPidsCopy = [...settings.show_pids];

    const newColumnPids =
      typeof showPidsCopy[columnIndex] === 'object' && !Array.isArray(showPidsCopy[columnIndex]) ? [showPidsCopy[columnIndex]]
      : Number.isInteger(showPidsCopy[columnIndex]) ? [{ pids: [showPidsCopy[columnIndex]] }]
      : Array.isArray(showPidsCopy[columnIndex]) ? [{ pids: [...showPidsCopy[columnIndex]] }]
      : [];

    showPidsCopy.splice(columnIndex, 1, newColumnPids);

    settings.show_pids = showPidsCopy;
    this.setState({ settings });
  };

  addNewShowPidToMultipleChains = ({ index, columnIndex, rstId }) => {
    const settings = { ...this.state.settings };
    const columnChainsArray = cloneDeep(settings.show_pids[columnIndex]);

    if (columnChainsArray[index]) {
      if (columnChainsArray[index].obj_editable_frm)
        delete columnChainsArray[index].obj_editable_frm;

      columnChainsArray[index].pids.push(rstId);
      settings.show_pids[columnIndex] = columnChainsArray;
    } else {
      settings.show_pids[columnIndex] = [...columnChainsArray, { pids: [rstId] }];
    }

    this.setState({ settings });
  };

  removePidInMultipleChains = ({ index, columnIndex }, newArr) => {
    const settings = { ...this.state.settings };
    const columnChainsArray = cloneDeep(settings.show_pids[columnIndex]);

    if (!newArr || newArr.length === 0) {
      columnChainsArray.splice(index, 1);
    } else {
      columnChainsArray[index].pids = Array.isArray(newArr) ? newArr : [newArr];
    }
    settings.show_pids[columnIndex] = columnChainsArray;

    this.setState({ settings });
  };

  onRstNestedDragEnd = (oldIndex, newIndex, columnIndex) => {
    const settings = { ...this.state.settings };
    const columnChainsArray = cloneDeep(settings.show_pids[columnIndex]);

    const arr = changeArrayElementPosition(columnChainsArray, oldIndex, newIndex);

    settings.show_pids[columnIndex] = arr;

    this.setState({ settings });
  };

  setColumnTitle = (columnIndex, title) => {
    const oldColumnTitles = this.state.settings.column_titles;
    const newColumnTitles = oldColumnTitles ? [...oldColumnTitles] : [];
    newColumnTitles[columnIndex] = title;
    newColumnTitles.length = this.state.settings.show_pids.length;

    this.setState({
      settings: { ...this.state.settings, column_titles: newColumnTitles }
    })

  };

  changeFieldInMainTable = (key, value) => {
    const settings = { ...this.state.settings };

    settings[key] = value;

    this.setState({ settings });
  };

  onSaveTableClick = () => {
    const settings = { ...this.state.settings };
    const { parentJelId, setParentJel } = this.props;

    if (settings.draft) {
      delete settings.id;
      delete settings.draft;
    }

    for (let index = 0; index < settings.show_pids.length; index++) {
      const value = settings.show_pids[index];

      if (value.hasOwnProperty('custom_component')) {
        const newComponent = value.custom_component.map(row => {
          const newRowChildren = row.children.map(column => {
            const newColumnChildren = column.children.map(comp => {
              //delete comp.id;
              return comp;
            });
            //delete column.id;
            return { ...column, children: newColumnChildren };
          });
          //delete row.id;
          return { ...row, children: newRowChildren };
        });
        settings.show_pids.splice(index, 1, { ...value, custom_component: newComponent });
      }

      const isValid = Number.isInteger(value)
        || (Array.isArray(value) && value.length)
        || (value.pids && value.pids.length)
        || (isJsonObject(value) && value.hasOwnProperty("custom_component"))
        || (isJsonObject(value) && value.hasOwnProperty("obj_editable_frm"));

      if (!isValid) {
        settings.show_pids.splice(index, 1);
        settings.column_titles.splice(index, 1);
        index--;
      }
    }

    if (!settings.type) settings.type = jelTypes.table;

    if (settings.trpl_filter) {
      settings.trpl_filter = settings.trpl_filter
        .filter(isNotPlaceholderFilter)
    } else {
      settings.trpl_filter = [];
    }

    this.setState({
      fetchingData: true
    }, () => {
      this.postWithData({
        data: settings,
        url: '/rest/upd_jel?type=trpls_tbl',
        cb: (data) => {
          if (data.status === 'ok') {
            const { trpls_tbl } = data;

            if (parentJelId && setParentJel) setParentJel(trpls_tbl.id, jelTypes.table);
            if (this.props.updateParentModalOnSave) this.props.updateParentModalOnSave(trpls_tbl);

            this.setState({
              settings: trpls_tbl,
            });

            this.props.updateJelsSimple();

            setTimeout(() => {
              this.setState({ fetchingData: false });
            }, 600);
          }
        },
      });
    });
  };

  onClose = () => {
    const { onClose } = this.props;

    onClose();

    this.setState({
      init: true,
      conceptId: 0,
      data: {
        setup: {
          locations: {},
        },
      },
      settings: {},
      editSettingsModal: {
        isOpened: false,
        path: '',
      },
      loaded: true,
    });
  };

  changeShowPidsRstPosition = (oldIndex, newIndex) => {
    let settings = cloneDeep(this.state.settings);

    settings.show_pids = changeArrayElementPosition(settings.show_pids, oldIndex, newIndex);

    this.setState({ settings });
  };

  onUpdateTableSelectChange = (e) => {
    const { value } = e.target;
    const settings = { ...this.state.settings };

    if (value === 'disabled') {
      delete settings.update_table_period;
    } else {
      settings.update_table_period = value;
    }

    this.setState({ settings });
  };

  onEditNodeFormSelectChange = (e) => {
    const { value } = e.target;
    const settings = { ...this.state.settings };
    const buttons = { ...settings.buttons };

    if (value === 'none' && buttons && buttons.editNode) {
      delete buttons.editNode;
    } else {
      buttons.editNode = value;
    }

    settings.buttons = buttons;

    this.setState({ settings });
  };

  onShowPidsFieldChange = (itemIndex, field, value, columnIndex) => {
    const settings = { ...this.state.settings };

    const newSettings = produce(settings, oldSettings => {
      const showPids = columnIndex !== null ? oldSettings.show_pids[columnIndex][itemIndex]
      : oldSettings.show_pids[itemIndex];
    
      if (columnIndex !== null) {
        if (isJsonObject(showPids)) {
          if ('none' === value) delete showPids[field];
          else showPids[field] = value;
        }
      } else {
        if (Number.isInteger(showPids) || Array.isArray(showPids)) {
          const newShowPids = {};
          newShowPids.pids = Array.isArray(showPids) ? showPids : [showPids];
          newShowPids[field] = value;
  
          oldSettings.show_pids[itemIndex] = newShowPids;
        } else if (isJsonObject(showPids)) {
          if ('none' === value) delete showPids[field];
          else showPids[field] = value;
        }
      }
    });

    this.setState({ settings: newSettings });
  };

  getUsedViews = (usedViews) => {
    this.setState({ usedViews })
  };

  handleRendererChange = (columnIndex, value, key) => {
    const settings = { ...this.state.settings };

    const newSettings = produce(settings, oldSettings => {
      const showPids = oldSettings.show_pids[columnIndex];

      if (isJsonObject(showPids)) {
        if (showPids.renderer) showPids.renderer[key] = value;
        else showPids.renderer = { [key]: value };

        oldSettings.show_pids[columnIndex] = showPids;

      } else if (Number.isInteger(showPids) || Array.isArray(showPids)) {
        const newShowPids = {};
        newShowPids.pids = Array.isArray(showPids) ? showPids : [showPids];

        newShowPids.renderer = { [key]: value };
        oldSettings.show_pids[columnIndex] = newShowPids;
      }
      if (value === true && key === 'editable_checkbox') {
        const rendererIcons = { false_icon: 'checkbox', true_icon: 'checkbox' };
        oldSettings.show_pids[columnIndex].renderer = { ...oldSettings.show_pids[columnIndex].renderer, ...rendererIcons };
      }
      if (value === false && key === 'editable_checkbox') delete oldSettings.show_pids[columnIndex].renderer[key];
      if (value === 'no icon' || key.toString() === value) delete oldSettings.show_pids[columnIndex].renderer[key];
      if (!Object.keys(oldSettings.show_pids[columnIndex].renderer).length) delete oldSettings.show_pids[columnIndex].renderer;
    });

    this.setState({ settings: newSettings });
  };

  onCustomLayoutColumnItemChange = (columnIndex, key, value) => {
    const settings = { ...this.state.settings };

    const newSettings = produce(settings, oldSettings => {
      oldSettings.show_pids[columnIndex][key] = value;
    });

    this.setState({ settings: newSettings });
  };

  onRstDragEnd = (oldIndex, newIndex) => {
    const settings = { ...this.state.settings };
    const show_pids = [...settings.show_pids];

    const arr = changeArrayElementPosition(show_pids, oldIndex, newIndex);
    settings.show_pids = arr;

    if (!settings.column_titles) settings.column_titles = [];
    settings.column_titles.length = settings.show_pids.length;

    const oldTitle = settings.column_titles[oldIndex];
    settings.column_titles.splice(oldIndex, 1);
    settings.column_titles.splice(newIndex, 0, oldTitle);

    this.setState({ settings });
  };

  addInnerRstCb = ({ index, rstId }) => {
    const settings = cloneDeep(this.state.settings);

    if (isJsonObject(settings.show_pids[index])) {
      if (settings.show_pids[index].obj_editable_frm)
        delete settings.show_pids[index].obj_editable_frm;

      settings.show_pids[index].pids = [...settings.show_pids[index].pids, rstId];
    } else if (Array.isArray(settings.show_pids[index])) {
      settings.show_pids[index] = [...settings.show_pids[index], rstId];
    } else {
      settings.show_pids[index] = [settings.show_pids[index], rstId];
    }

    this.setState({ settings });
  };

  removeInnerRst = ({ index }, newArr) => {
    const { setup_rbox_light } = this.props.light_meta_and_ops;
    const settings = cloneDeep(this.state.settings);

    if (isJsonObject(settings.show_pids[index])) {
      settings.show_pids[index].pids = newArr;
      if (settings.show_pids[index].renderer) delete settings.show_pids[index].renderer;

      if (settings.show_pids[index].obj_editable_frm) {
        let deleteObjEditableFrm = true;

        if (newArr.length > 0) {
          const { jelData } = this.props.jels;

          const form = jelData[settings.show_pids[index].obj_editable_frm];
          const lastRstNewArr = getLastRstData(newArr, settings.concept, setup_rbox_light);

          if (form && lastRstNewArr) {
            const conceptFormSupers = get(setup_rbox_light,
              [form.concept, 'box', 't_supers_implicit'],
              []);
            conceptFormSupers.push(form.concept);
            deleteObjEditableFrm = !conceptFormSupers.includes(lastRstNewArr.oid);
          }
        }

        if (deleteObjEditableFrm) delete settings.show_pids[index].obj_editable_frm;
      }
    } else if (newArr.length === 1) {
      settings.show_pids[index] = newArr[0];
    } else {
      settings.show_pids[index] = newArr;
    }

    this.setState({ settings });
  };

  getFirstRstIdInChain = (rstChain) => {
    if (!Array.isArray(rstChain)) {
      return rstChain;
    }
    return rstChain[0];
  }

  removeNonExistingRestrictions = () => {
    const settings = { ...this.state.settings };
    const show_pids = [...settings.show_pids];
    const column_titles = settings.column_titles ? [...settings.column_titles] : [];

    const { conceptRestrictionsIds } = this.state;

    const newShowPids = show_pids.filter((rstChain) => {
        if (isJsonObject(rstChain)) rstChain = rstChain.pids;

        return conceptRestrictionsIds.includes(
          this.getFirstRstIdInChain(rstChain)
        );
      }
    );

    const pidsToRemove = show_pids.filter(n => newShowPids.indexOf(n) === -1);

    let indexesToRemove = pidsToRemove.map((currentPid) => {
      const removedPidIndex = show_pids.findIndex(i => i === currentPid);
      return removedPidIndex;
    });

    let newColumnTitles = column_titles.filter(function(e, i){
      return indexesToRemove.indexOf(i) < 0;
    });

    settings.column_titles = newColumnTitles;
    settings.show_pids = newShowPids;

    this.setState({ settings });
  };

  openFrmEditModal = (frmId, showPidsFormData) => {
    let settings = cloneDeep(this.state.settings);
    let editFrmModal = { ...this.state.editFrmModal };

    const formConcept = showPidsFormData ? showPidsFormData.concept : settings.concept || 0;

    const newForm = {
      createMode: true,
      concept: formConcept,
      title: '',
      groups: [],
    };

    if (!frmId) {
      editFrmModal = {
        isOpened: true,
        form: {
          ...newForm,
        },
      };
    } else {
      const { jelData } = this.props.jels;
      const form = jelData[frmId];

      editFrmModal.form = form;
      editFrmModal.isOpened = true;
    }

    if (showPidsFormData) editFrmModal.showPidsIndex = showPidsFormData.showPidsIndex;

    this.setState({ editFrmModal });
  };

  setCreatedFrm = (id) => {
    const settings = { ...this.state.settings };
    const editFrmModal = { ...this.state.editFrmModal };

    if (editFrmModal.showPidsIndex || editFrmModal.showPidsIndex === 0) {
      const showPid = settings.show_pids[editFrmModal.showPidsIndex];
      showPid.obj_editable_frm = id;

      editFrmModal.form.id = id;
    } else {
      if (!settings.buttons) settings.buttons = {};

      settings.buttons.editNode = id;
      editFrmModal.form.id = id;
    }

    this.setState({ settings, editFrmModal });
  };

  addNewShowPid = ({ rstId }) => {
    const settings = { ...this.state.settings };
    const showPidsArr = [...settings.show_pids, rstId];
    if (settings.column_titles) settings.column_titles.length = this.state.settings.show_pids.length + 1;

    settings.show_pids = showPidsArr;

    this.setState({ settings });
  };

  addCustom = () => {
    const settings = { ...this.state.settings };
    const showPidsArr = [...settings.show_pids, { custom_component: [], type: 'custom', id: (new Date().getTime())}];
    if (settings.column_titles) settings.column_titles.length = this.state.settings.show_pids.length + 1;

    settings.show_pids = showPidsArr;

    this.setState({ settings });
  };

  addThisNodeRow = () => {
    const settings = { ...this.state.settings };
    const showPidsArr = [...settings.show_pids, { title: '' }];
    if (settings.column_titles) settings.column_titles.length = this.state.settings.show_pids.length + 1;

    settings.show_pids = showPidsArr;

    this.setState({ settings });
  };

  setFiltersToState = (initialFilters) => {
    const { settings } = this.state;

    const toNonNullFields = filter => Object.fromEntries(
      Object.entries(filter)
        .filter(
          ([key, value]) => value != null
        )
    );

    const cleanedfilters = initialFilters
      .filter(isNotPlaceholderFilter)
      .map(toNonNullFields)

    const newSettings = {
      ...settings,
      trpl_filter: cleanedfilters
    };

    this.setState({ initialFilters, settings: newSettings });
  };

  onFiltersSearchNodeCb = (node) => {
    const { data } = this.state;
    const nodes = { ...data.nodes };

    nodes[node.id] = node;
    data.nodes = nodes;

    this.setState({ data });
  };

  onSortPidSelectChange = (value) => {
    let settings = cloneDeep(this.state.settings);

    if (value) {
      settings.sort_pid = value;
      settings.sort_by = 1;
      settings.sort_desc = false;
    } else {
      delete settings.sort_desc;
      settings.sort_pid = '';
    }

    this.setState({ settings });
  };

  setSorters = (sorters) => {
    const settings = { ...this.state.settings };

    this.setState({
      settings: {
        ...settings,
        ...sorters,
      },
    });
  };

  getAllPidsFromShowPids = (showPids) => {
    if (!showPids) return;
    const result = [];

    for (let showPid of showPids) {
      const pids = getPidsFromShowPids(showPid);
      if (pids) result.push(pids);
    }

    return result;
  };

  render() {
    const {
      jels,
      classes,
      modalIndex,
      deepCopyView,
      onCopyViewBtnClick
    } = this.props;

    const {
      data,
      loaded,
      settings,
      conceptId,
      addItemType,
      editFrmModal,
      fetchingData,
      isInAnotherJel,
      initialFilters,
      deepCopyLoaded,
      conceptRestrictionsIds,
    } = this.state;

    let hasNotValidRst = false;

    const showPids = this.getAllPidsFromShowPids(settings.show_pids);

    if (showPids) {
      showPids.forEach(rstId => {
        const id = Array.isArray(rstId) ? rstId[0] : rstId;
        if (isJsonObject(id) && Array.isArray(id.pids)) {
          if (!conceptRestrictionsIds.includes(id.pids[0])) hasNotValidRst = true;
        } else
        if (!conceptRestrictionsIds.includes(id)) hasNotValidRst = true;
      });
    }

    const isInAnotherJelHeight =
      isInAnotherJel && document.querySelector(`.is-in-another-jel-container`)
        ? document.querySelector(`.is-in-another-jel-container`).getBoundingClientRect().height
        : '';

    const tableRestrictions = showPids || [];
    const allRestrictions = tableRestrictions.concat(conceptRestrictionsIds).filter(onlyUnique);

    const currentModalIndex = modalIndex ? modalIndex : 0;

    return (
      <div>
        <FullScreenDialog
          modalIndex={currentModalIndex}
          onClose={() => {
            this.setState({
              editFrmModal: {
                isOpened: false,
                data: {},
              },
            });

            this.props.updateJels();
          }}
          isOpen={editFrmModal.isOpened}
          disableContainerPadding={true}
          title={
            settings.buttons && settings.buttons.editNode && editFrmModal.form
              ? `Form edit - ${editFrmModal.form.title} | ${editFrmModal.form.id}`
              : `Form create`
          }
        >
          <TrplFormEdit
            modalIndex={currentModalIndex + 1}
            nodesData={data.nodes}
            form={editFrmModal.form}
            parentJelId={settings.id}
            setParentJel={this.setCreatedFrm}
            deepCopyView={deepCopyView}
            onCopyViewBtnClick={onCopyViewBtnClick}
          />
        </FullScreenDialog>

        {isInAnotherJel ? (
          <div className={`is-in-another-jel-container ${classes.isInAnotherJelContainer}`}>
            <div style={{ textAlign: 'center' }}>
              <span className={`${classes.bold} ${classes.nowrap} ${classes.mr5}`}>
                {settings.id
                  ? `${settings.id} ${settings.title}`
                  : `${this.props.settings.id} ${this.props.settings.title}`}
              </span>
              <span className={`${classes.mr5} ${classes.nowrap}`}> is used in: </span>
              <span className={classes.bold}>{isInAnotherJel}</span>
            </div>

            <ButtonBase
              className={`${classes.btn} ${classes.secondaryBtn} ${classes.ml30}`}
              onClick={() => onCopyViewBtnClick(jelTypes.table, { ...settings })}
              style={{
                visibility: `${jels.importedForms.includes(settings.id) ? 'hidden' : ''}`,
              }}
            >
              Copy view
              <ContentCopyIcon
                style={{
                  fontSize: '13px',
                  marginLeft: '4px',
                  color: '#347CFF',
                }}
              />
            </ButtonBase>
          </div>
        ) : null}

        {loaded ? (
          <Paper
            className={classes.container}
            style={{
              marginBottom: '150px',
              marginTop: `${isInAnotherJel ? `${isInAnotherJelHeight}px` : ''}`,
            }}
          >
            <div className={`${classes.alignStart} ${classes.mb5}`}>
              <div className={`${settings.concept ? classes.mb10 : ''}`}>
                {loaded && !settings.concept ? (
                  <Typography className={classes.mb10} variant="h6">
                    Please, select concept
                  </Typography>
                ) : null}

                <div className={classes.alignCenter}>
                  <TextField
                    fullWidth
                    label="Table title"
                    value={settings.title}
                    className={`${classes.w200} ${classes.mr20} ${classes.tableEditInput}`}
                    onChange={(e) => this.changeFieldInMainTable('title', e.target.value)}
                  />

                  <div className={`${classes.alignCenter} ${classes.mr20}`}>
                    {conceptId && data.nodes && data.nodes[conceptId] ? (
                      <Node
                        isLink
                        size="md"
                        isRemovable
                        nodeId={conceptId}
                        node={data.nodes[conceptId]}
                        nodes={data.nodes}
                        className={classes.mr10}
                        style={{ alignSelf: 'center' }}
                        onRemoveClick={() => this.setState({ conceptId: null })}
                      />
                    ) :  <Search conceptsOnly={true} onDropdownElementClick={(node) => this.onMainConceptChange(node)} />}
                  </div>
                </div>
              </div>

              {fetchingData ? null :
                <React.Fragment>
                  <div className={classes.ml30}>
                    <ViewUsesTree
                      loaded={fetchingData}
                      node={settings.id}
                      classes={classes}
                      data={jels.jelData}
                      setUsedViewsToParent={this.getUsedViews}
                    />
                  </div>

                  {Object.keys(this.state.usedViews).length > 1 ?
                    <div className={`${classes.ml30}`}>
                      <ButtonBase
                        disabled={!deepCopyLoaded}
                        className={`${classes.btn} ${classes.secondaryBtn} ${classes.ml30}`}
                        onClick={() => {
                          this.setState({ deepCopyLoaded: false });
                          deepCopyView(this.state.settings.id, this.state.usedViews, () => this.setState({ deepCopyLoaded: true }));
                        }}
                      >
                        {deepCopyLoaded ?
                          <React.Fragment>
                            Copy view deep
                            <ContentCopyIcon
                              style={{
                                fontSize: '13px',
                                marginLeft: '4px',
                                color: '#347CFF',
                              }}
                            />
                          </React.Fragment>
                        : <LoaderNew/>}
                      </ButtonBase>
                    </div>
                  : null}
                </React.Fragment>
              }
            </div>

            <RstFilters
              nodes={data.nodes}
              classes={classes}
              settings={settings}
              initialFilters={initialFilters}
              pidsForFilters={allRestrictions}
              pidsForSorters={tableRestrictions}
              filtersCallbacks={{
                onFilterBtnClick: this.setFiltersToState,
                onFiltersSearchNodeCb: this.onFiltersSearchNodeCb,
              }}
              sortersCallbacks={{
                setSorters: this.setSorters,
                onAddInitialRst: () => {
                  this.forceUpdate();
                },
              }}
            />

            {settings.concept && loaded ? (
              <div>
                <div
                  style={{
                    pointerEvents: !conceptId && settings.show_pids.length ? 'none' : '',
                    opacity: !conceptId && settings.show_pids.length ? 0.5 : 1
                  }}
                >
                  <OtherControls
                    nodes={data.nodes}
                    classes={classes}
                    settings={settings}
                    conceptId={conceptId}
                    hasNotValidRst={hasNotValidRst}
                    openFrmEditModal={this.openFrmEditModal}
                    changeFieldInMainTable={this.changeFieldInMainTable}
                    onUpdateTableSelectChange={this.onUpdateTableSelectChange}
                    onEditNodeFormSelectChange={this.onEditNodeFormSelectChange}
                    removeNonExistingRestrictions={this.removeNonExistingRestrictions}
                  />

                  <div className={classes.mb20}>
                    {settings.show_pids && settings.show_pids.length ? (
                      <Restrictions
                        data={data}
                        jels={jels}
                        classes={classes}
                        settings={settings}
                        onRstDragEnd={this.onRstDragEnd}
                        addInnerRstCb={this.addInnerRstCb}
                        removeInnerRst={this.removeInnerRst}
                        setColumnTitle={this.setColumnTitle}
                        onRemoveRstClick={this.onRemoveRstClick}
                        openFrmEditModal={this.openFrmEditModal}
                        onRstNestedDragEnd={this.onRstNestedDragEnd}
                        conceptRestrictionsIds={conceptRestrictionsIds}
                        handleRendererChange={this.handleRendererChange}
                        onShowPidsFieldChange={this.onShowPidsFieldChange}
                        changeShowPidsRstPosition={this.changeShowPidsRstPosition}
                        changeFieldEditSettingsModal={this.changeFieldEditSettingsModal}
                        switchColumnToMultipleChains={this.switchColumnToMultipleChains}
                        addNewShowPidToMultipleChains={this.addNewShowPidToMultipleChains}
                        onCustomLayoutColumnItemChange={this.onCustomLayoutColumnItemChange}
                        removePidInMultipleChains={this.removePidInMultipleChains}
                      />
                    ) : null}
                  </div>

                  <div className={`${classes.alignEnd} ${classes.mb10}`}>
                    <div className={`${classes.mr10} ${classes.w200}`}>
                      <TrplSelect
                        title="Row type"
                        margin="none"
                        complicatedValues
                        values={[
                          { title: 'Predicate', value: 'predicate' },
                          { title: 'Custom', value: 'custom' },
                          { title: 'This node', value: 'this_node' },
                        ]}
                        value={addItemType || 'predicate'}
                        onChange={(e) => {
                          this.setState({ addItemType: e.target.value });
                        }}
                      />
                    </div>

                    {addItemType === 'predicate' ? (
                      <div className={`${classes.mt10}`} style={{ width: '100%' }}>
                        <PredicateChain
                          mode="edit"
                          disableChain
                          ancestor={settings.concept}
                          addInnerRstCb={this.addNewShowPid}
                          show_pids={settings.show_pids}
                        />
                      </div>
                    ) : addItemType === 'custom' ? (
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        style={{
                          marginTop: '17px',
                        }}
                        className={`${classes.mt20}`}
                        onClick={() => {
                          this.addCustom();
                        }}
                      >
                        Add custom
                      </Button>
                    ) : (
                      <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        style={{
                          marginTop: '17px',
                        }}
                        className={`${classes.mt20}`}
                        onClick={() => {
                          this.addThisNodeRow();
                        }}
                      >
                        Add this node edit
                      </Button>
                    )}
                  </div>
                </div>

                {!jels.importedTables.includes(settings.id) &&
                  <div className={classes.justifyEnd}>
                    {!conceptId && settings.show_pids.length ?
                      <span className={classes.mr10} style={{ color: 'red', alignSelf: 'center' }}>Select table concept</span>
                    : !settings.title ?
                      <span className={classes.mr10} style={{ color: 'red', alignSelf: 'center' }}>Set table title</span>
                    : null}

                    <Button
                      size="small"
                      color="primary"
                      variant="contained"
                      disabled={!settings.title || (!conceptId && settings.show_pids.length)}
                      onClick={this.onSaveTableClick}
                    >
                      {fetchingData ? <LoaderNew color='#FFF' style={{ height: '22.75px' }} /> : 'Save'}
                    </Button>
                  </div>
                }
              </div>
            ) : null}
          </Paper>
        ) : (
          <div
            style={{
              display: 'flex',
              marginTop: '50px',
              justifyContent: 'center',
            }}
          >
            <LoaderNew />
          </div>
        )}
      </div>
    );
  }
}

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  light_meta_and_ops: state.meta.light_meta_and_ops,
}), {
  updateJels,
  updateJelsSimple,
})(withStyles(styles)(TableEdit));
